import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "480px",
    height: "100%",
    padding: theme.spacing(3.5),
  },
  title: {
    fontSize: "24px",
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  },
  taskTitle: {
    color: grey[600],
    fontSize: "14px",
    fontWeight: 400,
  },
  radioGroup: {
    display: "flex",
  },
  signatureOptionContainer: {
    border: `1px solid ${grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    backgroundColor: grey[50],
  },
  editModal: {
    width: "100%",
    backgroundColor: grey[50],
  },
  labelText: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.disabled,
  },
}));
